export default __webpack_public_path__ + "static/media/icn-calendar.09ab6516.svg";